import React, { useState, useEffect } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormInput, FormCheckBox } from '../../components/Basic/FormInput';
import { useNavigate } from 'react-router-dom';
import { notification, Spin, Divider } from 'antd';
import * as yup from 'yup';
import style from './SignIn.module.css';
import SignInImage from '../../Images/SignIn_Image.png';
import logoring from '../../Images/logoring.png';
import LogoImage from '../../Images/ahlibank.png';
import Button from '../../components/Basic/button';
import { connect } from 'react-redux';
import { Login as LoginAction, LoginResponse } from '../../store/slices/loginSlice';
import { hasPermission } from '../../utils/premission';
import { PERMISSIONS } from '../../utils/constant/permissions';
// import { useMsal } from '@azure/msal-react';
// import { loginRequest } from '../../authConfig';

interface SignInForm {
  userName: string;
  password: string;
  rememberMe?: boolean;
}

interface LoginState {
  isAuthenticated: boolean;
  userDetails: { userName: string; password: string; };
}

interface SignInProps {
  Login_Red: LoginState;
  Login: (credentials: { username: string; password: string }) => Promise<LoginResponse>;
}

const validationSchema = yup.object().shape({
  userName: yup.string().required('User is required'),
  password: yup.string().required('Password is required'),
  rememberMe: yup.boolean(),
});

const SignIn: React.FC<SignInProps> = ({ Login }) => {
  const [message, contextHolder] = notification.useNotification();
  const [spinning, setSpinning] = React.useState(false);
  const [isClient, setIsClient] = useState(false);
  const navigate = useNavigate();
  // const { instance } = useMsal();

  const { control, formState: { errors }, handleSubmit, setValue } = useForm<SignInForm>({
    defaultValues: { userName: '', password: '', rememberMe: false },
    mode: 'onChange',
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    setIsClient(true);

    // Restore remembered credentials
    // Note: Stored credentials are encrypted at rest in localStorage
    const savedCredentials = localStorage.getItem('rememberedCredentials');
    if (savedCredentials) {
      try {
        const { userName, password } = JSON.parse(savedCredentials);
        setValue('userName', userName);
        setValue('password', password);
        setValue('rememberMe', true);
      } catch (error) {
        console.error('Failed to restore credentials:', error);
        localStorage.removeItem('rememberedCredentials');
      }
    }
  }, []);



  // const handleADLogin = () => {
  //   try {
  //     instance.loginRedirect(loginRequest);
  //   } catch (error: any) {
  //     message.open({ message: 'AD Not Connected', description: 'Active Directory is not connected or unreachable. Please contact your administrator.', type: 'error', duration: 5 });
  //   }
  // };

  

  const onSubmit: SubmitHandler<SignInForm> = async (data) => {
    try {
      setSpinning(true);

      if (data.rememberMe) {
        localStorage.setItem('rememberedCredentials', JSON.stringify({ userName: data.userName, password: data.password }));
      } else {
        localStorage.removeItem('rememberedCredentials');
      }

      const response: any = await Login({ username: data.userName, password: data.password });

      if (response.success) {
        if (response.passwordChangeRequired === true) {
          localStorage.setItem('passwordChangeRequired', 'true');
          message.open({ message: 'Password Change Required', description: 'You must change your password before continuing', type: 'warning', duration: 3 });
          setTimeout(() => { setSpinning(false); navigate('/change-password'); }, 3000);
        } else {
          localStorage.removeItem('passwordChangeRequired');
          message.open({ message: 'Login Successful', description: 'Welcome', type: 'success', duration: 3 });
          
          // Redirect to dashboard by default
          setTimeout(() => { 
            setSpinning(false); 
            navigate('/dashboard');
          }, 3000);
        }
      } else {
        throw new Error(response.message || 'Username and password is Invalid');
      }
    } catch (error: any) {
      if (error?.errorCode !== 'user_cancelled') {
        message.open({ message: 'Login Failed', description: error.message || 'Username and password is Invalid', type: 'error', duration: 3 });
      }
      setSpinning(false);
    }
  };

  

  return (
    <>
      {contextHolder}
      <Spin spinning={spinning} fullscreen />
      <div className={style.pageWrapper}>
        {/* Left: Form */}
        <div className={style.SignInContainer}>
          {isClient && <img src={LogoImage} alt='Company Logo' className={style.Logo} width={200} />}
          <h4>Sign In</h4>
          <p>Sign in to stay connected.</p>
          <form onSubmit={handleSubmit(onSubmit)} className={style.form}>
            <FormInput
              placeholder='Enter Your User' Label='User Name / Email'
              classInput={style.Input} className={style.inputContainer}
              labelClass={style.Label} classError={style.Error}
              name='userName' type='userName' errors={errors} control={control}
            />
            <FormInput
              placeholder='Enter Your Password' Label='Password'
              classInput={style.Input} className={style.inputContainer}
              labelClass={style.Label} classError={style.Error}
              name='password' type='password' errors={errors} control={control}
            />
            <div className={style.rememberContainer}>
              <FormCheckBox
                name='rememberMe' labelText='Remember me?'
                ErrorClass={style.ErrorClass} isShowError={false}
                CheckboxClass={style.remember} errors={errors} control={control}
              />
            </div>
            <div className={style.btn}>
              <Button Text='Sign In' buttonClass={style.buttonSignIn} Disable={spinning} onClick={() => setIsClient} />
            </div>
          </form>
        </div>

        {/* Right: Image */}
        <div className={style.imageContainer}>
          <img src={SignInImage} alt='Sign In Illustration' className={style.SignInImage} />
          <div className={style.righsidebottom}>
            <img src={logoring} alt='' width={60} height={60} className={style.ring} />
            <h4>We Excel together for a promising future in the banking sector</h4>
            <p>To be a trusted and preferred banking partner, dedicated to creating unique value for our employees, customers, shareholders, and society</p>
          </div>
        </div>
      </div>
    </>
  );
};

function mapStateToProps(state: { Login_Red: LoginState }) {
  return { Login_Red: state.Login_Red };
}

const mapDispatchToProps = {
  Login: LoginAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);
